import { toast } from 'react-toastify';
import { axiosRequest } from '../../service';
import { REACT_APP_VAM_CONTEXT_FIELD, REACT_APP_VAM_CONTEXT_INGESTION, REACT_APP_VAM_CONTEXT_SURVEYOR, REACT_APP_VAM_CONTEXT_VENDOR, REACT_APP_VAM_ENDPOINT } from '../../urls';

export const fetchSurveyorList = async (vendorId) => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_SURVEYOR}/getSurveyorAndQCMasterList/${vendorId.id}`
    );
    return response.data.map((list) => ({
      id: list.surveyorId,
      label: `${list.firstName} ${list.lastName ? list.lastName : ''} ${
        list.mobileNumber ? `(${list.mobileNumber})` : ''
      }`,
      value: `${list.firstName} ${list.lastName ? list.lastName : ''}`,
    }));
  } catch (error) {
    console.error('Error fetching surveyor list:', error);
    throw error;
  }
};

export const fetchVendorsList = async () => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_VENDOR}/getVendorList/Survey`
    );
    return response?.data?.map((list) => ({
      id: list.vendorId,
      label: list.vendorName,
      value: list.vendorName,
    }));
  } catch (error) {
    console.error('Error fetching vendors list:', error);
    throw error;
  }
};

export const submitBulkSurveyAction = async (
    notifyPayload,
    roleDataCookie,
    filteredData,
    isReSurvey = false,
    fieldResurveyData = null
  ) => {
    try {
      let endpoint = isReSurvey
        ? `${REACT_APP_VAM_ENDPOINT}/kfieldsurveyservice/api/v1/fieldsurvey/bulk/reassign-surveyor`
        : `${REACT_APP_VAM_ENDPOINT}/kfieldsurveyservice/api/v1/fieldsurvey/bulk/assign-surveyor`;

      let payload = {
        surveyorName: notifyPayload.surveyorName,
        surveyorMobile: notifyPayload.surveyorMobile,
        vendorName: notifyPayload.vendorName,
        surveyInitiatedBy: roleDataCookie.userID,
        surveyorId: notifyPayload.surveyorID,
        claims: filteredData,
      };

      if (isReSurvey) {
        payload.comments = notifyPayload.comments;
      }

      const response = await axiosRequest().post(endpoint, payload);
      const { successCount, failureCount } = response.data;
      const totalCount = successCount + failureCount;

      if (successCount > 0) {
        toast.success(`Task sync successful (${successCount} of ${totalCount})`);
      }
      if (failureCount > 0) {
        toast.error(`Task sync failed (${failureCount} of ${totalCount})`);
      }

      return response.data;
    } catch (error) {
      console.error(`Error in submitBulk${isReSurvey ? 'ReSurvey' : 'Survey'}:`, error);
      throw error;
    }
  };

export const fetchFieldSurveyDataApi = async (page, size, fieldnames) => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}/fieldsurvey/assignment?page=${
        page ? page : fieldnames.page
      }&size=${size ? size : fieldnames.size}&seasonName=${fieldnames.seasonName}&seasonYear=${
        fieldnames.seasonYear
      }&productId=${fieldnames.productId}&state=${fieldnames.state}&district=${
        fieldnames.district
      }&mandal=${fieldnames.mandal}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching field survey data:', error);
    throw error;
  }
};

export const fetchFieldReSurveyDataApi = async (page, size, fieldnames, vendorId, surveyorId) => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}/fieldsurvey/reassignment?page=${
        page ? page : fieldnames.page
      }&size=${size ? size : fieldnames.size}&state=${fieldnames.state}&vendorName=${
        vendorId.value
      }&surveyorName=${surveyorId.value}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching field re-survey data:', error);
    throw error;
  }
};

export const uploadApiHelper = {
  uploadBulkFieldSurvey: async (formData) => {
    try {
      const response = await axiosRequest().post(
        `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_FIELD}/notifyBulkFieldSurvey`,
        formData
      );
      return response.data;
    } catch (error) {
      console.error('Error uploading bulk field survey:', error);
      throw error;
    }
  },
};